<template>
  <div class="mapbox">
    <div class="closebtn" @click="$emit('goBack')">关闭 ×</div>
    <!-- <img :src="currentImage" class="detail-img" /> -->
    <div class="imgbox">
      <div v-for="(img, i) in images" :key="i" class="image-wrap">
        <img :src="img" class="image" />
        <div class="image-name">{{ imageNames[i] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmerDetail',

  //接收图片index参数
  props: {
    farmerImageIndex: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      images: [
        // require('../assets/images/farmer_products/product1.png'),
        require('../assets/images/farmer_products/goods1.jpeg'),
        require('../assets/images/farmer_products/goods2.jpeg'),
        require('../assets/images/farmer_products/goods3.jpeg'),
        require('../assets/images/farmer_products/goods4.jpeg')
      ],
      imageNames: ['优质稻', '澳龙新品', '优质饲料', '复合肥']
    }
  },

  computed: {
    currentImage() {
      return this.images[this.farmerImageIndex]
    }
  }
}
</script>

<style scoped>
.mapbox {
  display: flex;
  height: 100%;
  padding: 16px;
  gap: 12px;
  flex-direction: column;
}

.closebtn {
  color: #83ffe1;
  text-align: right;
  margin: 20px 15px;
  cursor: pointer;
}

.detail-img {
  width: 100%;
  height: 80%;
  object-fit: fill;
  border-radius: 8px;
  padding: 15px 20px;
}

.imgbox {
  display: flex;
  align-items: center;
  height: 80%;
  flex-wrap: wrap;
  justify-content: center;
}

.image-wrap {
  width: 35%;
  margin: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.image {
  height: 220px;
  width: 100%;
  display: block;
}

.image-name {
  margin-top: 6px;
  color: #dffcff;
  font-size: 20px;
  text-align: center;
  white-space: nowrap;
  letter-spacing: 2px;
}
</style>
